import { render, staticRenderFns } from "./DownloadModal.vue?vue&type=template&id=c8bf46fc&scoped=true"
import script from "./DownloadModal.vue?vue&type=script&lang=js"
export * from "./DownloadModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadModal.vue?vue&type=style&index=0&id=c8bf46fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bf46fc",
  null
  
)

export default component.exports